module.exports = __webpack_public_path__ + "static/media/img28.6f039b29.jpg";